module.exports = __webpack_public_path__ + "static/media/Orcamentos5.7a23e199.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos5.png
// module id = 2100
// module chunks = 0